import { Timeline } from '@/components/ui/timeline'
import { type Sequence, SequenceStatus, SequenceStepStatus } from '@/models/sequence'
import { SequenceTimelineStep } from './SequenceTimelineStep'

export function SequenceTimeline({ sequence }: { sequence: Sequence }) {
  if (sequence.steps.length === 0) {
    return <p className="text-muted-foreground text-sm">This sequence has no steps.</p>
  }

  const paused = sequence.status === SequenceStatus.PAUSED
  const live = paused || sequence.status === SequenceStatus.RUNNING
  const currentId = live ? sequence.steps.find((s) => s.status === SequenceStepStatus.PENDING)?.id : undefined

  return (
    <Timeline>
      {sequence.steps.map((step) => (
        <SequenceTimelineStep key={step.id} step={step} current={step.id === currentId} paused={paused} />
      ))}
    </Timeline>
  )
}
